import { useCallback } from "react";

import { useDispatch, useSelector } from "react-redux";

import { RVButton } from "@regal-voice/ui";
import {
    expandStickyNotes,
    selectStickyNodes,
    selectExpandedStickyNoteNodes,
} from "Services/state/journeys/JourneyStateSlice";

import styles from "./ExpandNotesButton.module.scss";

export function ExpandNotesButton(): JSX.Element {
    const dispatch = useDispatch();
    const stickyNotes = useSelector(selectStickyNodes);
    const expandedNotes = useSelector(selectExpandedStickyNoteNodes);
    const expanded = stickyNotes.length == Object.keys(expandedNotes).length;

    const handleOnClick = useCallback(() => dispatch(expandStickyNotes(!expanded)), [dispatch, expanded]);

    return stickyNotes.length > 0 ? (
        <RVButton className={styles.expandNotesButton} onClick={handleOnClick}>
            {expanded ? "Collapse" : "Expand"} {stickyNotes.length} Notes
        </RVButton>
    ) : (
        <></>
    );
}
